import {MaintenanceService} from '../../libs/ui/src/index';
import {apiMaintenance} from '../apiMaintenance';

const _MaintenanceService = new MaintenanceService({client: apiMaintenance});
export {_MaintenanceService as MaintenanceService};
